import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import TopBar from '../components/Dashboard/TopBar'; 
import MenuItemCard from './MenuItemCard';
import MenuManager from './MenuManager';

/* ============================================================
   API FUNCTION
============================================================ */
const fetchFoodCategoriesFromDB = async () => {
  const API_ENDPOINT = '/api/food-categories';
  try {
    const response = await fetch(API_ENDPOINT);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching food categories:", error);
    return [];
  }
};

/* ============================================================
   CATEGORY BAR
============================================================ */
const AppetizerBar = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadCategories = async () => {
      const data = await fetchFoodCategoriesFromDB();
      setCategories(data);
      setLoading(false);
    };
    loadCategories();
  }, []);

  const handleAddCategory = () => {
    console.log("Open add category modal");
  };

  const handleCategoryPress = (category) => {
    console.log("Navigate to category:", category.name);
  };

  if (loading) {
    return (
      <div style={styles.loaderWrapper}>
        <div style={styles.spinner}></div>
        <p style={{ marginTop: 10, color: '#ae7d54', fontWeight: '500' }}>Loading Categories...</p>
      </div>
    );
  }

  return (
    <div style={styles.scrollContainer}>
      <div style={styles.scrollInner}>
        {categories.length > 0 &&
          categories.map((category) => (
            <MenuItemCard
              key={category.id}
              category={category}
              onPress={handleCategoryPress}
            />
          ))}
        <MenuItemCard onAddPress={handleAddCategory} />
      </div>
    </div>
  );
};

/* ============================================================
   MAIN PAGE
============================================================ */
const MenuPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div style={{ display: 'flex', height: '100vh', width: '100%', overflow: 'hidden', backgroundColor: '#f3f4f6', position: 'relative' }}>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css" />
      
      <style>{`
        .sidebar-container {
            width: 260px;
            height: 100vh;
            flex-shrink: 0;
            background: #fff;
            transition: transform 0.3s ease;
            z-index: 1000;
        }

        .main-content-layout {
            flex-grow: 1;
            height: 100vh;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            width: calc(100% - 260px);
            transition: all 0.3s ease;
        }

        @media (max-width: 1024px) {
          .sidebar-container { 
            position: fixed;
            left: 0;
            top: 0;
            transform: translateX(-100%); 
          }
          .sidebar-container.open { transform: translateX(0); }
          .main-content-layout { width: 100%; }
          .sidebar-overlay {
            display: none;
            position: fixed;
            inset: 0;
            background: rgba(0,0,0,0.5);
            z-index: 999;
          }
          .sidebar-overlay.active { display: block; }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>

      <div 
        className={`sidebar-overlay ${isSidebarOpen ? 'active' : ''}`} 
        onClick={toggleSidebar}
      />

      <div className={`sidebar-container ${isSidebarOpen ? 'open' : ''}`}>
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      </div>

      <main className="main-content-layout">
        <TopBar onMenuClick={toggleSidebar} isSidebarOpen={isSidebarOpen} />

        <div style={{ padding: '8px', flex: 1 }}>
          
          {/* Centered Page Title Section */}
          <div style={styles.header}>
            <h2 style={styles.title}>Restaurant Menu Categories</h2>
            </div>

          {/* Category Bar Section */}
          <div style={{ marginBottom: '30px', borderRadius: '12px', overflow: 'hidden' }}>
            <AppetizerBar />
          </div>

          {/* Menu Manager Section */}
          <div style={styles.managerWrapper}>
            <MenuManager />
          </div>

        </div>
      </main>
    </div>
  );
};

/* ============================================================
   STYLES OBJECT
============================================================ */
const styles = {
  header: {
    marginBottom: "32px",
    textAlign: "center", // Centered as requested
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  title: {
    fontSize: "28px",
    fontWeight: 700,
    color: "#ae7d54", 
    marginBottom: "0px",
    letterSpacing: "-0.5px"
  },
  subtitle: {
    color: '#6B7280', 
    fontSize: '15px',
    maxWidth: '500px',
    lineHeight: '1.5'
  },
  scrollContainer: {
    width: "100%",
    overflowX: "auto",
    padding: "20px 0",
    backgroundColor: "#ffffff",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    borderRadius: "16px"
  },
  scrollInner: {
    display: "flex",
    flexDirection: "row",
    gap: "16px",
    padding: "0 20px",
    minWidth: "max-content",
    // To keep centered cards if they don't fill width
    justifyContent: "center", 
  },
  loaderWrapper: {
    padding: "40px",
    textAlign: "center",
    backgroundColor: "#fff",
    borderRadius: "12px"
  },
  spinner: {
    width: "32px",
    height: "32px",
    border: "4px solid rgba(174, 125, 84, 0.1)",
    borderLeftColor: "#ae7d54",
    borderRadius: "50%",
    display: "inline-block",
    animation: "spin 1s linear infinite",
  },
  managerWrapper: {
    marginTop: "10px",
  },
};

export default MenuPage;